
export function getDefaultKennzahlenDefinition(): any[] {
    return [
        {
            'name': 'Anzahl der Filialen',
            'kuerzel': 'filialen',
            'beschreibung': 'Anzahl der Filialen',
            'einheit': '',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Mitarbeitende (Vollzeitäquivalent)',
            'kuerzel': 'mitarbeiter',
            'beschreibung': 'Mitarbeitende (Vollzeitäquivalent)',
            'einheit': '',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Umsatz',
            'kuerzel': 'umsatz',
            'beschreibung': 'Umsatz',
            'einheit': '€',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Beheizte Gebäudefläche',
            'kuerzel': 'flaeche',
            'beschreibung': 'Beheizte Gebäudefläche',
            'einheit': 'm²',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Eigenstromnutzung',
            'kuerzel': 'eigenstrom_nutzung_kwh',
            'beschreibung': 'Eigenstromnutzung',
            'einheit': 'ja/nein',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Eigenstromverbrauch',
            'kuerzel': 'eigenstrom_verbrauch_kwh',
            'kuerzel_db': 'eigenstrom_verbrauch',
            'beschreibung': 'Eigenstromverbrauch',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Eigenstromeinspeisung',
            'kuerzel': 'eigenstrom_einspeisung_kwh',
            'beschreibung': 'Eigenstromeinspeisung',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Strom: Jahresverbrauch Fremdbezug',
            'kuerzel': 'strom_verbrauch_fremdbezug',
            'beschreibung': 'Strom: Jahresverbrauch Fremdbezug',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Strom: Jahresverbrauch gesamt',
            'kuerzel': 'strom_verbrauch_gesamt',
            'beschreibung': 'Strom: Jahresverbrauch gesamt',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Strom: Gesamtkosten (netto)',
            'kuerzel': 'strom_kosten_gesamt',
            'beschreibung': 'Strom: Gesamtkosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Biogas: Jahresverbrauch',
            'kuerzel': 'verbrauch_waerme_biogas_kwh',
            'beschreibung': 'Biogas: Jahresverbrauch',
            'einheit': 'kwh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Biogas: Kosten (netto)',
            'kuerzel': 'kosten_waerme_biogas',
            'beschreibung': 'Biogas: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Biomasse - Brennholz: Jahresverbrauch',
            'kuerzel': 'verbrauch_waerme_bio_brennholz_kwh',
            'beschreibung': 'Biomasse - Brennholz: Jahresverbrauch',
            'einheit': 'kwh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Biomasse - Brennholz: Kosten (netto)',
            'kuerzel': 'kosten_waerme_bio_brennholz',
            'beschreibung': 'Biomasse - Brennholz: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Biomasse - Hackschnitzel: Jahresverbrauch',
            'kuerzel': 'verbrauch_waerme_bio_hackschnitzel_kwh',
            'beschreibung': 'Biomasse - Hackschnitzel: Jahresverbrauch',
            'einheit': 'kwh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Biomasse - Hackschnitzel: Kosten (netto)',
            'kuerzel': 'kosten_waerme_bio_hackschnitzel',
            'beschreibung': 'Biomasse - Hackschnitzel: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Biomasse - Pellets: Jahresverbrauch',
            'kuerzel': 'verbrauch_waerme_bio_holzpellets_kwh',
            'beschreibung': 'Biomasse - Pellets: Jahresverbrauch',
            'einheit': 'kwh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Biomasse - Pellets: Kosten (netto)',
            'kuerzel': 'kosten_waerme_bio_holzpellets',
            'beschreibung': 'Biomasse - Pellets: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Erdgas: Jahresverbrauch',
            'kuerzel': 'verbrauch_waerme_erdgas_kwh',
            'kuerzel_db': 'gas_verbrauch_kwh',
            'beschreibung': 'Erdgas: Jahresverbrauch',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Erdgas: Kosten (netto)',
            'kuerzel': 'kosten_waerme_erdgas',
            'kuerzel_db': 'gas_kosten',
            'beschreibung': 'Erdgas: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Flüssiggas: Jahresverbrauch',
            'kuerzel': 'verbrauch_waerme_fluessiggas_kwh',
            'beschreibung': 'Flüssiggas: Jahresverbrauch',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Flüssiggas: Kosten (netto)',
            'kuerzel': 'kosten_waerme_fluessiggas',
            'beschreibung': 'Flüssiggas: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Fernkälte: Jahresverbrauch',
            'kuerzel': 'verbrauch_waerme_fernkaelte_kwh',
            'beschreibung': 'Fernkälte: Jahresverbrauch',
            'einheit': 'kwh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Fernkälte: Kosten (netto)',
            'kuerzel': 'kosten_waerme_fernkaelte',
            'beschreibung': 'Fernkälte: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Fernwärme: Jahresverbrauch',
            'kuerzel': 'verbrauch_waerme_fernwaerme_kwh',
            'kuerzel_db': 'fw_verbrauch',
            'beschreibung': 'Fernwärme: Jahresverbrauch',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Fernwärme: Kosten (netto)',
            'kuerzel': 'kosten_waerme_fernwaerme',
            'kuerzel_db': 'fw_kosten',
            'beschreibung': 'Fernwärme: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Heizöl: Jahresverbrauch',
            'kuerzel': 'oel_verbrauch_l',
            'beschreibung': 'Heizöl: Jahresverbrauch',
            'einheit': 'l/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Heizöl: Jahresverbrauch',
            'kuerzel': 'verbrauch_waerme_hel_kwh',
            'kuerzel_db': 'oel_verbrauch_kwh',
            'beschreibung': 'Heizöl: Jahresverbrauch',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Heizöl: Kosten (netto)',
            'kuerzel': 'kosten_waerme_hel',
            'kuerzel_db': 'oel_kosten',
            'beschreibung': 'Heizöl: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Kohle - Braunkohle: Jahresverbrauch',
            'kuerzel': 'verbrauch_waerme_braunkohle_kwh',
            'beschreibung': 'Kohle - Braunkohle: Jahresverbrauch',
            'einheit': 'kwh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Kohle - Braunkohle: Kosten (netto)',
            'kuerzel': 'kosten_waerme_braunkohle',
            'beschreibung': 'Kohle - Braunkohle: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Kohle - Steinkohle: Jahresverbrauch',
            'kuerzel': 'verbrauch_waerme_steinkohle_kwh',
            'beschreibung': 'Kohle - Steinkohle: Jahresverbrauch',
            'einheit': 'kwh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Kohle - Steinkohle: Kosten (netto)',
            'kuerzel': 'kosten_waerme_steinkohle',
            'beschreibung': 'Kohle - Steinkohle: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Sonstige Wärmeträger: Jahresverbrauch',
            'kuerzel': 'verbrauch_waerme_andere_kwh',
            'kuerzel_db': 'andere_verbrauch_kwh',
            'beschreibung': 'Sonstige Wärmeträger: Jahresverbrauch',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Sonstige Wärmeträger: Kosten (netto)',
            'kuerzel': 'kosten_waerme_andere',
            'kuerzel_db': 'andere_kosten',
            'beschreibung': 'Sonstige Wärmeträger: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Heizen mit elektrischer Energie',
            'kuerzel': 'strom_heizen_elektrisch',
            'beschreibung': 'Heizen mit elektrischer Energie',
            'einheit': 'ja/nein',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Jahresstromverbrauch elektrische Heizung',
            'kuerzel': 'verbrauch_waerme_strom_kwh',
            'kuerzel_db': 'strom_verbrauch_heizen_elektrisch',
            'beschreibung': 'Jahresstromverbrauch elektrische Heizung',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Kosten elektrische Heizung (netto)',
            'kuerzel': 'kosten_waerme_strom',
            'kuerzel_db': 'kosten_heizen_elektrisch',
            'beschreibung': 'Kosten elektrische Heizung (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Benzin: Jahresverbrauch (Liter)',
            'kuerzel': 'benzin_verbrauch',
            'beschreibung': 'Benzin: Jahresverbrauch',
            'einheit': 'l/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Benzin: Jahresverbrauch (kWh)',
            'kuerzel': 'benzin_kwh',
            'beschreibung': 'Benzin: Jahresverbrauch',
            'einheit': 'kwh/a',
            'is_gewerk': null,
            'is_berechnet': 0,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Benzin: Kosten (netto)',
            'kuerzel': 'benzin_kosten',
            'beschreibung': 'Benzin: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Biodiesel: Jahresverbrauch (Liter)',
            'kuerzel': 'biodiesel_verbrauch',
            'beschreibung': 'Biodiesel: Jahresverbrauch',
            'einheit': 'l/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Biodiesel: Jahresverbrauch (kWh)',
            'kuerzel': 'biodiesel_kwh',
            'beschreibung': 'Biodiesel: Jahresverbrauch',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Biodiesel: Kosten (netto)',
            'kuerzel': 'biodiesel_kosten',
            'beschreibung': 'Biodiesel: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Bioethanol: Jahresverbrauch (Liter)',
            'kuerzel': 'bioethanol_verbrauch',
            'beschreibung': 'Bioethanol: Jahresverbrauch',
            'einheit': 'l/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Bioethanol: Jahresverbrauch (kWh)',
            'kuerzel': 'bioethanol_kwh',
            'beschreibung': 'Bioethanol: Jahresverbrauch',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Bioethanol: Kosten (netto)',
            'kuerzel': 'bioethanol_kosten',
            'beschreibung': 'Bioethanol: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Erdgas - CNG: Jahresverbrauch',
            'kuerzel': 'erdgas_cng_kg_verbrauch',
            'beschreibung': 'Erdgas - CNG: Jahresverbrauch',
            'einheit': 'kg/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Erdgas - CNG: Kosten (netto)',
            'kuerzel': 'erdgas_cng_kg_kosten',
            'beschreibung': 'Erdgas - CNG: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Erdgas - LNG: Jahresverbrauch',
            'kuerzel': 'erdgas_lng_kg_verbrauch',
            'beschreibung': 'Erdgas - LNG: Jahresverbrauch',
            'einheit': 'kg/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Erdgas - LNG: Kosten (netto)',
            'kuerzel': 'erdgas_lng_kg_kosten',
            'beschreibung': 'Erdgas - LNG: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'LPG: Jahresverbrauch (Liter)',
            'kuerzel': 'lpg_verbrauch',
            'beschreibung': 'LPG: Jahresverbrauch (Liter)',
            'einheit': 'l/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'LPG: Jahresverbrauch (kWh)',
            'kuerzel': 'lpg_kwh',
            'beschreibung': 'LPG: Jahresverbrauch (kWh)',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'LPG: Kosten (netto)',
            'kuerzel': 'lpg_kosten',
            'beschreibung': 'LPG: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Wasserstoff: Jahresverbrauch (kg)',
            'kuerzel': 'wasserstoff_kg_verbrauch',
            'beschreibung': 'Wasserstoff: Jahresverbrauch (kg)',
            'einheit': 'kg/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Wasserstoff: Jahresverbrauch (kWh)',
            'kuerzel': 'wasserstoff_kwh',
            'beschreibung': 'Wasserstoff: Jahresverbrauch (kWh)',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Wasserstoff: Kosten (netto)',
            'kuerzel': 'wasserstoff_kg_kosten',
            'beschreibung': 'Wasserstoff: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Diesel: Jahresverbrauch (Liter)',
            'kuerzel': 'diesel_verbrauch',
            'beschreibung': 'Diesel: Jahresverbrauch',
            'einheit': 'l/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Diesel: Jahresverbrauch (kWh)',
            'kuerzel': 'diesel_kwh',
            'beschreibung': 'Diesel: Jahresverbrauch',
            'einheit': 'kwh/a',
            'is_gewerk': null,
            'is_berechnet': 0,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Diesel: Kosten (netto)',
            'kuerzel': 'diesel_kosten',
            'beschreibung': 'Diesel: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Ladestrom: Jahresverbrauch',
            'kuerzel': 'ladestrom_verbrauch',
            'beschreibung': 'Ladestrom: Jahresverbrauch',
            'einheit': 'kwh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Ladestrom: Kosten (netto)',
            'kuerzel': 'ladestrom_kosten',
            'beschreibung': 'Ladestrom: Kosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Kraftstoffe: Jahresverbrauch',
            'kuerzel': 'kraftstoff_kwh',
            'beschreibung': 'Kraftstoffe: Jahresverbrauch',
            'einheit': 'kwh/a',
            'is_gewerk': null,
            'is_berechnet': 1,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Kraftstoffe: Jahresgesamtkosten (netto)',
            'kuerzel': 'kraftstoffe_kosten',
            'beschreibung': 'Kraftstoffe: Jahresgesamtkosten (netto)',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Kraftstoffe: Erdgasverbrauch',
            'kuerzel': 'erdgas_kraftstoff_kwh',
            'beschreibung': 'Kraftstoffe: Erdgasverbrauch',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Kraftstoffe: Erdgaskosten',
            'kuerzel': 'erdgas_kraftstoff_kosten',
            'beschreibung': 'Kraftstoffe: Erdgaskosten',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Wasser: Jahresverbrauch',
            'kuerzel': 'wasser_verbrauch_jahr',
            'beschreibung': 'Wasser: Jahresverbrauch',
            'einheit': 'm³/a',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Wasser: Jahresgesamtkosten (netto)',
            'kuerzel': 'wasser_kosten',
            'beschreibung': 'Wasser: Jahresgesamtkosten (netto)',
            'einheit': '€',
            'is_gewerk': null,
            'is_berechnet': null,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'CO₂-Emission (BAFA/KfW)',
            'kuerzel': 'co2_emission',
            'beschreibung': 'CO₂-Emission (BAFA/KfW)',
            'einheit': 't/a',
            'is_gewerk': null,
            'is_berechnet': 0,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'CO₂-Emission ohne Kraftstoffe (BAFA/KfW)',
            'kuerzel': 'co2_emission_ohne_kraftstoffe',
            'beschreibung': 'CO₂-Emission ohne Kraftstoffe (BAFA/KfW)',
            'einheit': 't/a',
            'is_gewerk': null,
            'is_berechnet': 0,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'CO₂-Strombedingte Emission',
            'kuerzel': 'co2_strom',
            'beschreibung': 'CO₂-Strombedingte Emission',
            'einheit': 't/a',
            'is_gewerk': null,
            'is_berechnet': 0,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'CO₂-Wärmebedingte Emission',
            'kuerzel': 'co2_waerme',
            'beschreibung': 'CO₂-Wärmebedingte Emission',
            'einheit': 't/a',
            'is_gewerk': null,
            'is_berechnet': 0,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Energiekosten / Umsatz',
            'kuerzel': 'energiekosten_umsatz',
            'beschreibung': 'Energiekosten / Umsatz',
            'einheit': '%',
            'is_gewerk': null,
            'is_berechnet': 1,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Stromverbrauch/Mitarbeitende:r',
            'kuerzel': 'strom_ma',
            'beschreibung': 'Stromverbrauch/ Mitarbeitende:r',
            'einheit': 'kWh/MA*a',
            'is_gewerk': null,
            'is_berechnet': 1,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Wärmeverbrauch - Alle Energieträger',
            'kuerzel': 'verbrauch_waerme_kwh',
            'beschreibung': 'Wärmeverbrauch - Alle Energieträger',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': 0,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Wärmekosten - Alle Energieträger',
            'kuerzel': 'kosten_waerme',
            'beschreibung': 'Wärmekosten - Alle Energieträger',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': 0,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Biomasseverbrauch ',
            'kuerzel': 'verbrauch_biomasse',
            'beschreibung': 'Biomasseverbrauch',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': 0,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Biomassekosten ',
            'kuerzel': 'kosten_biomasse',
            'beschreibung': 'Biomassekosten',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': 0,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Wärmemenge/Mitarbeitende:r',
            'kuerzel': 'waerme_ma',
            'beschreibung': 'Wärmemenge/Mitarbeitende:r',
            'einheit': 'kWh/MA*a',
            'is_gewerk': null,
            'is_berechnet': 1,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Gesamtenergieeinsatz/Mitarbeitende:r',
            'kuerzel': 'energieverbrauch_ma',
            'beschreibung': 'Gesamtenergieeinsatz/Mitarbeitende:r',
            'einheit': 'kWh/MA*a',
            'is_gewerk': null,
            'is_berechnet': 1,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'CO₂-Emission/Mitarbeitende:r',
            'kuerzel': 'co2_mitarbeiter',
            'beschreibung': 'CO₂-Emission/Mitarbeitende:r',
            'einheit': 't/MA*a',
            'is_gewerk': null,
            'is_berechnet': 1,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Energiekosten/Mitarbeitende:r',
            'kuerzel': 'energiekosten_ma',
            'beschreibung': 'Energiekosten/Mitarbeitende:r',
            'einheit': '€',
            'is_gewerk': null,
            'is_berechnet': 1,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Gesamtverbrauch',
            'kuerzel': 'gesamtverbrauch',
            'kuerzel_db': 'verbrauch_total',
            'beschreibung': 'Gesamtverbrauch',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': 0,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Gesamtkosten',
            'kuerzel': 'kosten_total',
            'beschreibung': 'Gesamtkosten',
            'einheit': '€/a',
            'is_gewerk': null,
            'is_berechnet': 0,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Anteil erneuerbare Energien am Gesamtverbrauch',
            'kuerzel': 'anteil_erneuerbar',
            'beschreibung': 'Anteil erneuerbare Energien am Gesamtverbrauch',
            'einheit': '%',
            'is_gewerk': null,
            'is_berechnet': 1,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Gesamtverbrauch ohne Kraftstoffe',
            'kuerzel': 'verbrauch_total',
            'kuerzel_db': 'verbrauch_total_ohne_kraftstoffe',
            'beschreibung': 'Gesamtverbrauch ohne Kraftstoffe',
            'einheit': 'kWh/a',
            'is_gewerk': null,
            'is_berechnet': 0,
            'umrechnung': null,
            'umrechnung_co2': null
        },
        {
            'name': 'Gesamtkosten ohne Kraftstoffe',
            'kuerzel': 'kosten_total_ohne_kraftstoffe',
            'beschreibung': 'Gesamtkosten ohne Kraftstoffe',
            'einheit': 't/a',
            'is_gewerk': null,
            'is_berechnet': 0,
            'umrechnung': null,
            'umrechnung_co2': null
        },
    ];
}
